import { FC, PropsWithChildren } from 'react'

import { classNames } from '@/utils/helpers'

interface Props {
  isMobileSidebarOpen: boolean
  isExpanded: boolean
}

export const SidebarContainer: FC<PropsWithChildren<Props>> = ({
  isMobileSidebarOpen,
  children,
  isExpanded,
}) => {
  return (
    <div
      className={classNames(
        'bg-card flex h-full w-full max-w-[82px] shrink-0 flex-col overflow-hidden border-r',
        isExpanded && 'max-w-[340px]',
        isMobileSidebarOpen && 'left-0 top-0 z-[40] max-lg:absolute',
        !isMobileSidebarOpen && 'max-lg:hidden',
      )}
    >
      {children}
    </div>
  )
}
